import React from 'react';
import styled from 'styled-components';
/* Displays the user-generated value in the menu (Add "...") */

var StyledDiv = styled.div.withConfig({
  componentId: "CL__sc-1y0lqvv-0"
})(["align-items:center;display:flex;flex-wrap:nowrap;font:inherit;gap:var(--spacing-1);margin:0;"]);

// Allows for ellipsis truncation
var StyledOverflowSpan = styled.span.withConfig({
  componentId: "CL__sc-1y0lqvv-1"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var CreatableLabel = inputValue => /*#__PURE__*/React.createElement(StyledDiv, null, /*#__PURE__*/React.createElement(StyledOverflowSpan, null, "Add \"".concat(inputValue, "\"")));
export default CreatableLabel;